import React from "react";

const Fallback = () => {
  return <div>Fallback</div>;
};

export default Fallback;
